import { render } from "./App.vue?vue&type=template&id=52c788a1"
const script = {}

import "./App.vue?vue&type=style&index=0&id=52c788a1&lang=css"

import exportComponent from "C:\\Users\\silvi\\OneDrive\\Escritorio\\eyesee\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__